import { render, staticRenderFns } from "./AssignEmployeeModalInStore.vue?vue&type=template&id=56c72e63&scoped=true"
import script from "./AssignEmployeeModalInStore.vue?vue&type=script&lang=js"
export * from "./AssignEmployeeModalInStore.vue?vue&type=script&lang=js"
import style0 from "./AssignEmployeeModalInStore.vue?vue&type=style&index=0&id=56c72e63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c72e63",
  null
  
)

export default component.exports